import { render, staticRenderFns } from "./EndYearModal.vue?vue&type=template&id=2b70df86&scoped=true"
import script from "./EndYearModal.vue?vue&type=script&lang=js"
export * from "./EndYearModal.vue?vue&type=script&lang=js"
import style0 from "./EndYearModal.vue?vue&type=style&index=0&id=2b70df86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70df86",
  null
  
)

export default component.exports